import { createSlice } from "@reduxjs/toolkit";
import { statuses } from "./constants";
import { userActions } from "./UserActions";
import {
  addPrize,
  deletePrize,
  editPrizes,
  editProfile,
  organizationPrizes,
  registerUser,
  scheduleReminder,
  kickUsers,
  organizationName,
  organizationMoods,
  changePassword,
  addPoints,
  chatReport,
  organizationData,
  organizationPoints,
  organizationUpdate,
  weeklyBonus,
  invitationCode,
  userChats,
  generalReport,
  organizationChats,
  chatMessages,
  setPassword,
  getAllOrganizations,
  addOrganization,
  deleteOrganization,
  setRewardPoints,
  setNotification,
  requestMood,
  redeemHistory,
  organizationUsers,
  resetPasswordAdmin,
  getNotifications,
  getUserList,
  getUserMessage,
  sendUserMessage,
  requestCloseCase,
  createOrganization,
  message,
} from "./UserActions";

import { UserReducers } from "./UserActions";

export const extraReducers = {
  ...UserReducers,
  [editProfile.fulfilled]: (state, action) => {
    if (action.payload.ID == state.user.ID) {
      state.user.firstName = action.payload.data.firstName;
      state.user.lastName = action.payload.data.lastName;
      state.user.countryCode = action.payload.data.countryCode;
      state.user.phoneNumber = action.payload.data.phoneNumber;
    } else {
      const idx = state.organizationUsers.findIndex(
        (usr) => usr._id["$oid"] === action.payload.ID
      );
      if (action.payload.data.hasOwnProperty("role"))
        state.organizationUsers[idx].role = action.payload.data.role;
      if (action.payload.data.hasOwnProperty("position"))
        state.organizationUsers[idx].position = action.payload.data.position;
      alert("Successful!");
    }
  },

  [editPrizes.fulfilled]: (state, action) => {
    state.organizationPrizes = action.payload.giftOptions;
    alert("Succcessful!");
  },

  [addPrize.fulfilled]: (state, action) => {
    state.organizationPrizes.push(action.payload);
  },

  [deletePrize.fulfilled]: (state, action) => {
    state.organizationPrizes = action.payload.giftOptions;
  },

  [organizationUsers.fulfilled]: (state, action) => {
    state.users = action.payload;
  },

  [organizationData.fulfilled]: (state, action) => {
    state.organization = action.payload;
  },

  [organizationName.fulfilled]: (state, action) => {
    state.organizationName = action.payload.Name;
    alert("Name successfully updated!");
  },

  [organizationPoints.fulfilled]: (state, action) => {
    state.organizationPoints = action.payload.Points;
    alert("Points successfully updated!");
  },

  [weeklyBonus.fulfilled]: (state, action) => {
    state.organizationWeeklyBonus = action.payload.Bonus;
    alert("Weekly Bonus successfully updated!");
  },

  [organizationMoods.fulfilled]: (state, action) => {
    state.organizationMoods = action.payload;
  },

  [organizationUpdate.fulfilled]: (state, action) => {
    state.organization = action.payload;
    alert("Organization Data Successfully updated!");
  },

  [registerUser.pending]: (state) => {
    state.registerStatus = statuses.pending;
  },
  [registerUser.fulfilled]: (state, action) => {
    state.users = action.payload;
    state.registerStatus = statuses.fulfilled;
  },
  [registerUser.rejected]: (state, action) => {
    alert(action.payload);
    state.registerStatus = statuses.rejected;
  },

  [changePassword.pending]: (state, action) => {
    state.passwordStatus = statuses.idle;
  },
  [changePassword.fulfilled]: (state, action) => {
    state.passwordStatus = statuses.fulfilled;
    alert("Password successfully changed!\nYou can close this window.");
  },
  [changePassword.rejected]: (state, action) => {
    state.passwordStatus = statuses.rejected;
    alert(action.payload);
  },

  [scheduleReminder.pending]: (state, action) => {
    state.scheduleReminderStatus = statuses.pending;
  },
  [scheduleReminder.fulfilled]: (state, action) => {
    state.scheduleReminderStatus = statuses.fulfilled;
    alert("Reminder Scheduled!");
  },
  [scheduleReminder.rejected]: (state, action) => {
    state.scheduleReminderStatus = statuses.rejected;
    alert(action.payload);
  },

  [addPoints.fulfilled]: () => {
    alert("Points successfully added!");
  },

  [invitationCode.fulfilled]: (state, action) => {
    state.invitationCode = action.payload.invitationCode;
  },

  [organizationChats.fulfilled]: (state, action) => {
    state.organizationChats = action.payload;
  },

  [chatMessages.pending]: (state) => {
    state.chatMessagesStatus = statuses.pending;
  },

  [chatMessages.fulfilled]: (state, action) => {
    state.chatMessages = action.payload;
    state.chatMessagesStatus = statuses.fulfilled;
  },

  [setPassword.fulfilled]: (state) => {
    state.registerStatus = statuses.idle;
  },

  [getAllOrganizations.fulfilled]: (state, action) => {
    state.allOrganizations = action.payload;
  },

  [addOrganization.fulfilled]: (state, action) => {
    state.allOrganizations.push(action.payload);
  },

  [deleteOrganization.fulfilled]: (state, action) => {
    state.allOrganizations = state.allOrganizations.filter(
      (org) => org.ID !== action.payload.id
    );
  },

  [setRewardPoints.fulfilled]: (state, action) => {
    state.RedeemMinimum = parseInt(action.payload.points);
    alert("Points updated successfully!");
  },

  [setNotification.fulfilled]: (state, action) => {
    state.notifications = action.payload;
    alert("Notification added successfully!");
  },

  [getNotifications.fulfilled]: (state, action) => {
    state.notifications = action.payload;
  },

  [getUserList.fulfilled]: (state, action) => {
    if (action.payload[0]?.status === "open")
      state.activeConversations = action.payload;
    else if (action.payload[0]?.status === "closed")
      state.archivedConversations = action.payload;
    else {
      state.activeConversations = [];
      state.archivedConversations = [];
    }
  },

  [getUserMessage.fulfilled]: (state, action) => {
    state.currentConversation = action.payload;
  },

  [redeemHistory.fulfilled]: (state, action) => {
    state.RedeemHistory = action.payload;
  },

  [sendUserMessage.fulfilled]: (state, action) => {
    state.currentConversation = action.payload;
  },

  [requestCloseCase.fulfilled]: (state, action) => {
    state.currentConversation = action.payload;
  },

  [resetPasswordAdmin.pending]: (state, action) => {
    state.resetPasswordAdminStatus = statuses.pending;
    state.resetPasswordAdminMessage =
      "Awaiting server response... Please wait.";
  },

  [resetPasswordAdmin.fulfilled]: (state, action) => {
    state.resetPasswordAdminStatus = statuses.fulfilled;
    state.resetPasswordAdminMessage = "Password updated successfully.";
  },

  [createOrganization.fulfilled]: (state, action) => {
    state.createOrganization = statuses.fulfilled;
    state.stripeCheckout = action.payload;
  },

  [resetPasswordAdmin.rejected]: (state, action) => {
    state.resetPasswordAdminStatus = statuses.rejected;
    state.resetPasswordAdminMessage =
      action.payload.message === undefined
        ? "Error occurred"
        : action.payload.message;
  },
};

export const UserSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    messages: {
      login: "",
    },
    status: {
      login: statuses.idle,
    },
    users: [],
    passwordStatus: statuses.idle,
    invitationCode: "",
    organizationChats: [],
    chatMessages: [],
    chatMessagesStatus: statuses.idle,
    registerStatus: statuses.idle,
    allOrganizations: [],
    Notification: "",
    RedeemMinimum: 0,
    notifications: [],
    RedeemHistory: [],
    RewardHistory: [],
    scheduledReminder: {},
    scheduleReminderStatus: statuses.idle,
    resetPasswordAdminStatus: statuses.idle,
    resetPasswordAdminMessage: "",
    messageStatus: statuses.idle,
    messageMessage: "",
    activeConversations: [],
    archivedConversations: [],
    currentConversation: {},
    lastMoods: [],
    priorities: [],
    reminders: [],
    currentUserMoods: [],
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.status.login = statuses.idle;
      state.messages.login = "";
      state.organization = [];
      state.users = [];
    },
  },
  extraReducers: extraReducers,
});

export const { logout } = UserSlice.actions;

export default UserSlice.reducer;
